module.exports = __webpack_public_path__ + "img/fondente_pack.7e2b3312.png";